import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "",
  description:
    "In this example an offline visualization and binaural auralization using physics-based room acoustic simulation is presented. Please wear headphones and listen to the example.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: [
        {
          variant: "blockContainer",
          data: {
            block: {
              type: "video",
              options: {
                src: `${config.ASSETS_URL}/03/16/principle/eurogress_binaural.mp4`,
              },
            },
            styles: {
              maxHeight: "70vh",
              maxWidth: "65vw",
            },
          },
        },
      ],
    },
  },
};

export default principle;
